export default "__VITE_ASSET__BfaPnMpc__"